import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const columns = [
  {
    title: 'Explore',
    links: [
      { label: 'About us', to: '/about' },
      { label: 'Narsimha', to: '/narsimha' },
      { label: 'Defence', to: '/defence' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Research', to: '/research' },
      { label: 'Investor', to: '/investor' },
      { label: 'Blog', to: '/blog' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Contact us', to: '/contact' },
      { label: 'Parts, Gear & Accessories', to: '/accessories' },
      { label: 'Book Test Ride', to: '/test-ride' },
    ],
  },
];

const socials = [
  { label: 'Twitter', icon: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.7 3h2.9l-6.4 7.3L21.8 21h-5.9l-4.6-6-5.3 6H3.1l6.9-7.8L2.5 3h6l4.1 5.5L17.7 3Zm-1 16.2h1.6L7.6 4.7H5.9l10.8 14.5Z" />
    </svg>
  ) },
  { label: 'Instagram', icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  ) },
  { label: 'Facebook', icon: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M14 9h2.5V6H14c-2 0-3.5 1.5-3.5 3.5V11H8v3h2.5v7h3v-7H16l.5-3h-3V9.8c0-.5.4-.8 1-.8Z" />
    </svg>
  ) },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Acriolis" className="footer__logo-img" />
            <span>ACRIOLIS</span>
          </Link>
          <p className="footer__tagline">
            Engineered for terrain.<br />
            Built for every adventure.
          </p>
          <div className="footer__socials">
            {socials.map((s) => (
              <a key={s.label} href="/" aria-label={s.label} className="footer__social">
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        <div className="footer__links">
          {columns.map((col) => (
            <div className="footer__col" key={col.title}>
              <h4 className="footer__col-title">{col.title}</h4>
              <ul className="footer__col-list">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="footer__col-link">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__bottom-left">
          <span className="footer__copy">© 2026 Acriolis. All rights reserved.</span>
          <div className="footer__legal">
            <Link to="/privacy-policy" className="footer__legal-link">Privacy Policy</Link>
          </div>
        </div>
        <div className="footer__celebration">
          <span className="footer__celebration-text">Proudly Celebrating 80 Years of India's Independence</span>
          <span className="footer__celebration-flag">🇮🇳</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
